export const SEED_USERS = [];

export const AI_PARTNER = {id:"ai_coach", name:"Sense Lifting Coach", color:"#C8A84B", isAI:true, mood:"great", mentalEnergy:100, physicalEnergy:100, intention:"Always here to play & grow with you", isResting:false};

export const MOOD_OPTIONS = [
  {id:"great",  emoji:"😄", label:"Geweldig", labelEN:"Great",   color:"#4AC87A", score:5},
  {id:"good",   emoji:"🙂", label:"Goed",     labelEN:"Good",    color:"#C8A84B", score:4},
  {id:"neutral",emoji:"😐", label:"Neutraal", labelEN:"Neutral", color:"#8899BB", score:3},
  {id:"low",    emoji:"😔", label:"Matig",    labelEN:"Low",     color:"#D4873A", score:2},
  {id:"bad",    emoji:"😞", label:"Slecht",   labelEN:"Bad",     color:"#C05050", score:1},
];

export const MOOD_TAGS_NL = ["Energiek","Rustig","Gestrest","Gefocust","Moe","Angstig","Dankbaar","Gelukkig","Geïrriteerd","Ontspannen","Productief","Overweldigd"];
export const MOOD_TAGS_EN = ["Energized","Calm","Stressed","Focused","Tired","Anxious","Grateful","Happy","Irritated","Relaxed","Productive","Overwhelmed"];

export const SEED_GROUPS = [];

export const SEED_HIGHSCORES = [];

export const NOTIF_TYPES = {
  friend_request:        {icon:"🤝", color:"#C8A84B"},
  friend_accepted:       {icon:"✅", color:"#4AC87A"},
  post_like:             {icon:"❤️", color:"#C05050"},
  profile_view:          {icon:"👁️", color:"#8899BB"},
  group_invite:          {icon:"🧩", color:"#7B6FD0"},
  group_accepted:        {icon:"🎉", color:"#4AC87A"},
  group_invite_accepted: {icon:"✅", color:"#4AC87A"},
  group_invite_declined: {icon:"✕",  color:"#C05050"},
  group_join_request:    {icon:"👥", color:"#7B6FD0"},
  group_joined:          {icon:"🎉", color:"#4AC87A"},
  game_invite:           {icon:"🎮", color:"#D4873A"},
  exercise_invite:       {icon:"🧘", color:"#2A9E82"},
  chat_message:          {icon:"💬", color:"#2ABFCF"},
  competition_new:       {icon:"⚔️", color:"#C8A84B"},
  coach_hire:            {icon:"🎓", color:"#C8A84B"},
  coach_contract_accepted:{icon:"✅", color:"#4AC87A"},
  coach_contract_declined:{icon:"❌", color:"#C05050"},
  booking_new:           {icon:"📅", color:"#5B9ED0"},
  credits_received:      {icon:"⚡", color:"#C8A84B"},
  admin_rights:          {icon:"🛡️", color:"#C8A84B"},
  lab_rights:            {icon:"🔬", color:"#2A9E82"},
};

export const SEED_NOTIFS = [];

export const TIPS = [
  {icon:"🧠",title:"Micro-recovery",tip:"Even 5 minutes of breathing between tasks reduces cortisol by up to 20%."},
  {icon:"🌊",title:"Box breathing",tip:"Inhale 4s → hold 4s → exhale 4s → hold 4s. Resets your nervous system instantly."},
  {icon:"⏱️",title:"90-min focus blocks",tip:"Your brain naturally cycles in ~90 min ultradian rhythms. Work with it, not against it."},
  {icon:"🌿",title:"Nature micro-dose",tip:"10 minutes outside, no phone, reduces anxiety markers by 21%."},
  {icon:"💤",title:"Sleep consistency",tip:"Going to bed at the same time every night is more restorative than extra hours."},
  {icon:"🎯",title:"Single-tasking",tip:"Switching tasks costs 20+ minutes of recovery time. One thing at a time is a superpower."},
  {icon:"🙏",title:"Gratitude timing",tip:"Writing 3 things you're grateful for before bed improves sleep quality and morning mood."},
  {icon:"💪",title:"Movement snacks",tip:"3-minute movement breaks every hour are as effective as one long workout for desk workers."},
];
